import { BehaviorSubject } from "rxjs";

const { buildErrResponse } = require("../_utils/utils");
const { BASE_URL, BASE_URL_DEV } = require("../_constants/urlConstants");
const { default: Axios } = require("axios");

const userExists = () => {
  return localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : {};
  //  msgs: "No se pudo recuperar el usuario de la sesión", status: 404
};

const currentToken = new BehaviorSubject(localStorage.getItem("token"));
const currentUserSubject = new BehaviorSubject(userExists());

export const AuthService = {
  login,
  logout,
  getUserInSession,
  currentUser: currentUserSubject.asObservable(),
  currentToken: currentToken.asObservable(),
  get currentUserValue() {
    return currentUserSubject.value;
  },
  get currentUserToken() {
    return currentToken.value;
  },
};

function login(credentials) {
  const { email, password } = credentials;
  return new Promise((resolve, reject) => {
    Axios.post(`${BASE_URL_DEV}/auth`, { email, password })
      .then((resp) => {
        currentUserSubject.next(resp.data.user);
        currentToken.next(resp.data.token);
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function logout() {
  // alert("call logout");
  localStorage.removeItem("user");
  localStorage.removeItem("token");
  currentUserSubject.next(null);
  currentUserSubject.next(null);
}

function getUserInSession() {
  return new Promise((resolve, reject) => {
    const user = localStorage.getItem("user");
    if (user) resolve({ status: 200, user: JSON.parse(user) });
    else
      reject({
        msgs: "No se pudo recuperar el usuario de la sesión",
        status: 404,
      });
  });
}
